<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    scrollable
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card member-point-dialog">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn text @click="close">{{ $t("close") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="$appMode == 0 &&
                  $store.state.store != null &&
                  $store.state.store.info != null
                "
                >{{ $store.getters.storeName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">{{
                $t("points")
              }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align: right"></v-col>
        </v-row>
      </v-toolbar>

      <v-card-text>
        <div class="points-summary" v-if="$store.state.member != null">
          <span class="points-title">{{ $t("points") }}</span>
          <span class="points-total">{{
            $store.state.member.MemberPointBalance
          }}</span>
        </div>
        <v-list>
          <v-list-item v-for="(tran, index) in memberPointTrans" :key="index">
            <v-list-item-content class="trans-container">
              <v-row align="center">
                <v-col cols="8">
                  <div class="trans-time">
                    {{ toLocaleString(tran.EventDate, false) }}
                  </div>
                  <div class="trans-remark">{{ tran.Remark }}</div>
                </v-col>
                <v-col cols="4" style="text-align: right">
                  <span :class="tran.Amount >= 0 ? 'trans-points' : 'trans-points-neg'">{{ tran.Amount }}</span>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    memberPointTrans: [],
  }),

  created() {},

  computed: {},

  methods: {
    open() {
      this.dialog = true;

      this.rest_getMember(this.$store.state.member.PhoneId).then((resp) => {
        if (resp.result == "ok") {
          this.$store.state.member = resp.record.child;
          this.rest_getMemberPointTrans(
            this.$store.state.member.MemberCode
          ).then((mpResp) => {
            if (mpResp.result == "ok") {
              this.memberPointTrans = mpResp.record;
            }
          });
        }
      });

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      this.resolve(true);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/member-point-dialog.scss";
</style>